import { render } from "./App.vue?vue&type=template&id=b645683a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b645683a&lang=css"

import exportComponent from "F:\\paratech\\al-sharaf\\new-admin\\al_sharaf_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__